import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'

import router from '@/router'
import store from '@/store'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  headers: {
    'content-type': 'application/json',
    'access-control-allow-origin': '*'
  }
})

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || ''
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Lógica para refrescar auth token
const refreshAuthLogic = (failedRequest) => {
  const returnUrl = encodeURIComponent(router.history.current.path ?? '/')
  if (!store.state.sesion.esValida)
    router.push(`/login?returnUrl=${returnUrl}`).catch(() => {})
  else
    store.dispatch('sesion/refreshToken').then((token) => {
      failedRequest.response.config.headers.Authorization = `Bearer ${token}`
      return Promise.resolve()
    })
  router.push(`/login?returnUrl=${returnUrl}`).catch(() => {})
}

// Instantiate the interceptor
createAuthRefreshInterceptor(instance, refreshAuthLogic)

export default instance
